import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setSubtypesMasters } from "../../../../redux/slices/activityTypes";
import { closeMegaSlider } from "../../../../redux/slices/sidebarSliders";
import { updateUserActivity } from "../../../../redux/slices/userActivity";
import { fetchMastersData } from "../../../../services/activity";

const pageSize = 10;

export default function MegaSlider({ megaSliderMasters, setMegaSliderMasters, activityTypeName, subtypeName, activityTypeId, activitySubtypeId }) {
  const dispatch = useDispatch();
  const handleClose = () => dispatch(closeMegaSlider());
  const [masters, setMasters] = useState(megaSliderMasters);
  const { selectedUserActivity } = useSelector((state) => state.userActivity);
  const currentPage = Math.ceil(megaSliderMasters.length / pageSize);
  console.log(currentPage);
  const [loading, setLoading] = useState(false);
  const [isLoadMoreVisible, setIsLoadMoreVisible] = useState(true);

  const handleClick = (master) => {
    dispatch(updateUserActivity({ activity: master, selectedActivityIdx: selectedUserActivity }));
  };

  const loadMore = () => {
    // dispatch(updateUserActivity({ activity: master, selectedActivityIdx: selectedUserActivity }));
    // console.log(activityTypeName)
    // console.log(subtypeName)
    console.log(currentPage + 1);
    setLoading(true);
    fetchMastersData(activityTypeName, subtypeName, currentPage + 1, (err, res) => {
      setLoading(false);
      if (err) {
        if (err.response.data.detail === "Invalid page.") {
          setIsLoadMoreVisible(false);
        }
        return;
      }
      // console.log(res.data)
      setMegaSliderMasters((prev) => {
        return [...prev, ...res.data.results];
      });
    });
  };

  return (
    <>
      <div style={{ marginBottom: "2rem", display: "flex", alignItems: "center" }}>
        <div className="icon-button" style={{ display: "flex", cursor: "pointer" }} onClick={handleClose}>
          <img src="/assets/icons/back-arrow.svg" width="20px" />
        </div>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {megaSliderMasters.map((master, idx) => {
          return (
            <div key={idx} style={{ marginBottom: "1.5rem", marginRight: "1rem" }} onClick={() => handleClick(master)}>
              <div className="sidebar_extension__slider__img_container">
                <img
                  className="skeleton"
                  onLoad={(e) => e.target.classList.remove("skeleton")}
                  alt=""
                  src={master.theme_id.thumbnail ? master.theme_id.thumbnail : "/assets/theme.png"}
                  style={{ maxWidth: "200px", maxHeight: "102px", objectFit: "cover" }}
                />
              </div>
            </div>
          );
        })}
      </div>
      {isLoadMoreVisible ? (
        <button onClick={loadMore} className="load-more-btn" disabled={loading}>
          {" "}
          Load more
        </button>
      ) : (
        <p style={{ color: "#fff", marginTop: "1rem", marginBottom: "1rem" }}>That's all</p>
      )}
    </>
  );
}
